<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-list-item>
        <v-list-item-icon v-if="icon">
          <v-icon size="32">{{ icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
          <v-list-item-title>
            <v-text-field
              v-if="type === 'String'"
              v-model="newValue"
              :label="subtitle"
              color="black"
              :rules="rules"
              :single-line="singleLine"
              :autofocus="autofocus"
              :readonly="readOnly"
              :type="type"
            />
            <v-text-field
              v-if="type === 'number'"
              v-model.number="newValue"
              :label="subtitle"
              color="black"
              :rules="rules"
              :single-line="singleLine"
              :autofocus="autofocus"
              :readonly="readOnly"
              :type="type"
            />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api';

export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default () {
        return [];
      }
    },
    type: {
      type: String,
      default: 'String'
    },
    autofocus: { type: Boolean },
    singleLine: { type: Boolean }
  },
  setup (props, context) {
    const newValue = ref(props.value);

    // v-model
    watch(newValue, () => {
      context.emit('input', newValue.value);
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    return { newValue };
  }
};
</script>
